import styled from 'styled-components';

const Root = styled.div``;

const SquadPage = () => {
  return <Root>Hello world</Root>;
};
export default SquadPage;
